const features = [
  {
    title: "Trending Products",
    desc: "Weekly updated lists of high-demand items sourced from verified China suppliers, organized by profit potential.",
    image: "https://readdy.ai/api/search-image?query=Assortment%20of%20trending%20diverse%20fashion%20products%20including%20warm%20toned%20sneakers%20rust%20scarf%20and%20leather%20accessories%20arranged%20artfully%20on%20cream%20surface%20soft%20natural%20lighting%20minimal%20editorial%20product%20curation%20photography%20clean%20modern%20aesthetic%20with%20variety%20of%20textures&width=500&height=667&seq=feature-trending-v2&orientation=portrait",
  },
  {
    title: "Supplier Intel",
    desc: "Compare suppliers side by side with transparent pricing, MOQ data, and reliability ratings built into every sheet.",
    image: "https://readdy.ai/api/search-image?query=Modern%20bright%20workspace%20with%20open%20laptop%20showing%20supplier%20comparison%20dashboard%20notebook%20with%20handwritten%20notes%20and%20steaming%20tea%20cup%20on%20warm%20oak%20desk%20cream%20wall%20background%20soft%20natural%20window%20light%20editorial%20productivity%20photography%20clean%20organized%20aesthetic&width=500&height=667&seq=feature-supplier-v2&orientation=portrait",
  },
  {
    title: "Profit Breakdown",
    desc: "See estimated margins, shipping costs, and resale price suggestions so you never overpay or underprice your listings.",
    image: "https://readdy.ai/api/search-image?query=Clean%20financial%20planning%20setup%20with%20small%20calculator%20charts%20colorful%20sticky%20notes%20and%20miniature%20product%20display%20items%20on%20cream%20desk%20surface%20soft%20natural%20lighting%20editorial%20business%20analytics%20photography%20warm%20optimistic%20aesthetic&width=500&height=667&seq=feature-profit-v2&orientation=portrait",
  },
];

export default function FeatureGrid() {
  return (
    <section className="py-24 md:py-32 px-6 md:px-10 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="mb-16 text-center">
          <h2 className="font-heading text-5xl md:text-6xl font-bold text-foreground-950">
            What You Get
            <span className="inline-block ml-2 text-3xl">✨</span>
          </h2>
          <p className="mt-4 text-foreground-600 text-lg max-w-[560px] mx-auto">
            Everything inside the itaobuy spreadsheet, built for real eCommerce sellers.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="group relative rounded-2xl overflow-hidden border border-background-200/50 transition-all duration-500 hover:shadow-sm cursor-default"
              style={{ aspectRatio: "3/4" }}
            >
              <img
                src={feat.image}
                alt={feat.title}
                className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/85 via-foreground-900/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                <h3 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-2">{feat.title}</h3>
                <p className="text-background-50/80 text-sm md:text-base leading-relaxed max-w-[90%] opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  {feat.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}